import { calcMaxGridSize } from './calcMaxGridSize';
export function calcCellSize() {
    return Math.floor(calcMaxGridSize() / 9);
}
